module.exports = __webpack_public_path__ + "img/title2.d1b38ebf.jpg";